import { useState, useEffect } from 'react'
import { Button, Modal } from 'antd';
import { QRCodeSVG } from 'qrcode.react';
import Api from '../../../utils/apis/Api';
import { toPng } from '../../../utils/helper/helper';
import './index.less';

export default function Home(props) {
    const [datas, setDatas] = useState([]);
    const [currentTab, setCurrentTab] = useState('1');
    const [qrEntry, setQrEntry] = useState(null);
    const tabs = [{
        key: '1',
        label: 'web网站'
    }, {
        key: '0',
        label: 'APP'
    }, {
        key: '2',
        label: '专题数据库'
    }]
    useEffect(() => {
        Api.appList().then(resp => {
            setDatas(resp.rows || [])
        })
    }, [])
    return <div className='fill layout-v h0 home'>
        <div className='layout-h fill h0'>
            <div className='fill layout-v' style={{
                background: "#08284d73",
                border: "1px solid #01E2F7",
                borderRadius: 10
            }}>
                <div className='layout-h center home-tabs' style={{
                    background: "#08284d66",
                    height: 80,
                    borderRadius: 10
                }}>
                    {tabs.map(item => {
                        return <div className='layout-h j-center home-tab' key={item.key} style={{
                            background: currentTab === item.key ? `url(${toPng('tabbg-sel')})` : `url(${toPng('tabbg')})`,
                            width: 228,
                            height: 68,
                            color: currentTab === item.key ? "#55EBE8" : "#fff",
                            fontSize: 26,
                            fontWeight: 'bold',
                            cursor: "pointer"
                        }} onClick={e => {
                            setCurrentTab(item.key)
                        }}>
                            <div style={{
                                marginTop: 12
                            }}>
                                {item.label}
                            </div>
                        </div>
                    })}
                </div>
                <div className='fill h0 app-list-wrap'>
                    <div className='app-grid'>
                        {datas?.filter(data => {
                            return data.type === currentTab
                        })?.map(data => {
                            return <div className='layout-v center j-center target-item' key={`${data.type}-${data.name}`} onClick={e => {
                                if (!data.url) return;
                                if (data.openType === 'qrcode') setQrEntry(data);
                                else window.open(data.url, '_blank');
                            }}>
                                <div className='layout-h center j-center target-icon' style={{
                                    background: `url(${toPng('itembg')})`
                                }}>
                                    <img alt={data.name} src={data.icon} />
                                </div>
                                <div className='target-name'>{data.name}</div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
        <Modal title={qrEntry?.name || '二维码'} open={Boolean(qrEntry)} footer={null} onCancel={() => setQrEntry(null)} centered>
            {qrEntry && <div className='preregistration-modal'>
                <QRCodeSVG data-testid='preregistration-qr' data-url={qrEntry.url} value={qrEntry.url} size={240} />
                <Button type='primary' size='large' onClick={() => window.open(qrEntry.url, '_blank')}>直接访问</Button>
            </div>}
        </Modal>
    </div>;
}
